import Dashboard from "../components/Dashboard"
import Anuncios from "../components/Anuncios"

const AnunciosPage = () => {

    return (
        <Dashboard>
            <Anuncios />
        </Dashboard>
    )
}

export default AnunciosPage
